import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Typography,
} from 'antd';
import React, { useEffect } from 'react';
import IntlMessage from '../../../components/IntlMessage';
import { useDispatch, useSelector } from 'react-redux';
import { updateSearchBookingValues } from '../../../redux/actions/CreateBookingAction';
import { useIntl } from 'react-intl';
import useTime from '../../../hooks/useTime';
import { paymentStatus } from '../payment.type';
import { orderStatus } from '../order_status.type';

const { Title } = Typography;
const { Option } = Select;
const PassengerInfoReturn = (props) => {
  const { isOpenPassenger, setIsOpenPassenger } = props;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const intl = useIntl();
  const { formatAsISOString, convertToAnyTimezone } = useTime();

  const searchValues = useSelector(
    (state) => state.createBookings.searchValues,
  );

  const returnDestination = useSelector((state) => state.createBookings.return);

  const onClosePassenger = () => {
    setIsOpenPassenger(false);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        setIsOpenPassenger(false);
        dispatch(
          updateSearchBookingValues({
            passengers: values.passengers,
            notes: values.notes,
          }),
        );
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  const onChangePayStatus = (e) => {};

  const onChangeOrderStatus = (e) => {};

  useEffect(() => {
    form.resetFields();
  }, [form]);

  return (
    <Drawer
      title={<IntlMessage id="global.passengers" />}
      width={'45%'}
      onClose={onClosePassenger}
      open={isOpenPassenger}>
      <Form
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        form={form}
        name="control-hooks"
        style={{ maxWidth: 1000 }}>
        {returnDestination.selectedSeat_return &&
          new Array(returnDestination.selectedSeat_return.length)
            .fill(0)
            .map((item, i) => {
              let firstCustomerIndex;
              let firstPassengerInfo = {
                firstname: null,
                lastname: null,
                passport: null,
                phone: null,
              };
              if (searchValues?.customer) {
                firstCustomerIndex = 0;
                firstPassengerInfo.firstname = searchValues?.customer.firstname;
                firstPassengerInfo.lastname = searchValues?.customer.lastname;
                firstPassengerInfo.phone = searchValues?.customer.mobile;
                firstPassengerInfo.passport =
                  searchValues?.customer.passport ?? '';
              }
              return (
                <>
                  <Title level={5}>Passager {i + 1}</Title>

                  <Row gutter={[16, 16]}>
                    <Col span={12}>
                      <Form.Item
                        label={<IntlMessage id="global.firstname" />}
                        name={['passengers', i, 'firstname']}
                        initialValue={
                          firstCustomerIndex === i
                            ? firstPassengerInfo.firstname
                            : ''
                        }
                        rules={[
                          {
                            required: true,
                            message: <IntlMessage id="global.requiredfield" />,
                          },
                        ]}>
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label={<IntlMessage id="global.lastname" />}
                        name={['passengers', i, 'lastname']}
                        initialValue={
                          firstCustomerIndex === i
                            ? firstPassengerInfo.lastname
                            : ''
                        }
                        rules={[
                          {
                            required: true,
                            message: <IntlMessage id="global.requiredfield" />,
                          },
                        ]}>
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col span={12}>
                      <Form.Item
                        label={<IntlMessage id="global.passport" />}
                        name={['passengers', i, 'passport']}
                        initialValue={
                          firstCustomerIndex === i
                            ? firstPassengerInfo.passport
                            : ''
                        }
                        rules={[
                          {
                            required: true,
                            message: <IntlMessage id="global.requiredfield" />,
                          },
                        ]}>
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label={<IntlMessage id="global.phone" />}
                        name={['passengers', i, 'phone']}
                        initialValue={
                          firstCustomerIndex === i
                            ? firstPassengerInfo.phone
                            : ''
                        }
                        rules={[
                          {
                            required: true,
                            message: <IntlMessage id="global.requiredfield" />,
                          },
                          {
                            message: <IntlMessage id={`global.numberfield`} />,
                            pattern: new RegExp(/^[0-9]+$/),
                          },
                        ]}>
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              );
            })}
        <Form.Item
          label={<IntlMessage id="global.order_status" />}
          name="order_status"
          style={{ marginTop: 20, width: 240 }}>
          <Select
            showSearch
            onChange={onChangeOrderStatus}
            filterOption={false}
            placeholder={intl.formatMessage({
              id: 'orders.order_status',
            })}>
            {orderStatus.map((item, index) => {
              return (
                <Option value={item.value} key={index}>
                  {item.label}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item
          label={<IntlMessage id="global.pay_status" />}
          name="pay_status"
          style={{ marginTop: 20, width: 240 }}>
          <Select
            showSearch
            onChange={onChangePayStatus}
            filterOption={false}
            placeholder={intl.formatMessage({
              id: 'global.payment_status',
            })}>
            {paymentStatus.map((item, index) => {
              return (
                <Option value={item.value} key={index}>
                  {item.label}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item
          label={<IntlMessage id="global.notes" />}
          name="notes"
          style={{ marginTop: 20 }}>
          <Input.TextArea
            placeholder={intl.formatMessage({
              id: 'global.input_order_notes',
            })}
            rows={4}
          />
        </Form.Item>
      </Form>
      <Button
        htmlType="submit"
        style={{
          background: '#14bb8c',
          color: '#FFF',
          cursor: 'pointer',
        }}
        onClick={handleOk}>
        <IntlMessage id="global.create" />
      </Button>
    </Drawer>
  );
};

export default PassengerInfoReturn;
